import React from 'react'
import Header from './header/Header.jsx'
import Training from './footer/Training.jsx'
import {trainingImg} from './data.js'
import ScrollToTopProgress from './header/ScrollToTopProgress.jsx'
import Menubar from './menubar/Menubar.jsx'
import Slides from './Slides.jsx'

function Main  () {
  return (
    <div>
        <Header/>
        <Menubar/>
        <Slides/>
        <Training Img={trainingImg}/>
        <ScrollToTopProgress/>
    </div>
  )
}

export default Main